import React, { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = ({ t, lang }) => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error(t.contact.error);
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, { ...form, locale: lang });
      toast.success(t.contact.success);
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(t.contact.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-[#110F0E]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="overline mb-5">{t.contact.overline}</p>
          <h2 className="font-serif font-light text-[#F3EFE9] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
            {t.contact.title}
          </h2>
          <p className="text-[#9D9287] text-base md:text-lg font-light leading-relaxed max-w-md">
            {t.contact.sub}
          </p>

          <div className="mt-12 space-y-4 border-t border-[#3A342E] pt-8">
            <div>
              <p className="overline">Atelier</p>
              <p className="font-serif text-xl text-[#F3EFE9] mt-2">Tbilisi · Georgia</p>
            </div>
            <div>
              <p className="overline">Press</p>
              <p className="font-mono text-sm text-[#F3EFE9] mt-2">press@kafkazstyle.co</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <form
            data-testid="contact-form"
            onSubmit={onSubmit}
            className="space-y-6 max-w-2xl"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="overline block mb-3" htmlFor="contact-name">{t.contact.name}</label>
                <input
                  id="contact-name"
                  data-testid="contact-name-input"
                  type="text"
                  required
                  value={form.name}
                  onChange={update("name")}
                  className="input-solid"
                />
              </div>
              <div>
                <label className="overline block mb-3" htmlFor="contact-email">{t.contact.email}</label>
                <input
                  id="contact-email"
                  data-testid="contact-email-input"
                  type="email"
                  required
                  value={form.email}
                  onChange={update("email")}
                  className="input-solid"
                />
              </div>
            </div>

            <div>
              <label className="overline block mb-3" htmlFor="contact-message">{t.contact.message}</label>
              <textarea
                id="contact-message"
                data-testid="contact-message-input"
                required
                rows={6}
                value={form.message}
                onChange={update("message")}
                className="input-solid"
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                data-testid="contact-submit-btn"
                disabled={loading}
                className="btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "..." : t.contact.submit}
                <Send size={14} strokeWidth={1.5} />
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
